/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerResident } from './ScreenerResident';
import {
    ScreenerResidentFromJSON,
    ScreenerResidentFromJSONTyped,
    ScreenerResidentToJSON,
    ScreenerResidentToJSONTyped,
} from './ScreenerResident';

/**
 * 
 * @export
 * @interface FindAllResidentsResponse
 */
export interface FindAllResidentsResponse {
    /**
     * 
     */
    data: Array<ScreenerResident>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllResidentsResponse interface.
 */
export function instanceOfFindAllResidentsResponse(value: object): value is FindAllResidentsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllResidentsResponseFromJSON(json: any): FindAllResidentsResponse {
    return FindAllResidentsResponseFromJSONTyped(json, false);
}

export function FindAllResidentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllResidentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScreenerResidentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllResidentsResponseToJSON(json: any): FindAllResidentsResponse {
    return FindAllResidentsResponseToJSONTyped(json, false);
}

export function FindAllResidentsResponseToJSONTyped(value?: FindAllResidentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ScreenerResidentToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

